module.exports = {"id":"217646","name":"Shūsaku Nishikawa","rating":"71","photo":"./data/images/photos/1/217646.png","club":{"name":"Urawa Diamonds","logo":"./data/images/clubs/UrawaDiamonds.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ShusakuNishikawa0.json
// module id = 3945
// module chunks = 0